import React from 'react';

function TextIconButton({
	Icon,
	text,
	colors,
	iconOnRightSide,
	classNameBTN = 'flex items-center md:pl-2 w-max text-xs md:text-base',
	classNameIMG = 'mr-4',
	classNameIMGRightSide = 'ml-4',
	classNameTXT = 'text-left',
	disabled,
	style,
	onClick = () => {}
}) {
	/* Variable that checks if any point of the component is being hovered so style can be applied to the Box */
	const [hover, setHover] = React.useState(false);

	/* Default values for the styles */
	const defaultStyle = {
		backgroundColor: hover ? colors?.light : colors?.background,
		color: colors?.text,
		transition: 'all 100ms ease-in',
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyle = { ...defaultStyle, ...style };

	/* Mouseover Styling */
	const onMouseOver = () => setHover(true);
	const onMouseLeave = () => setHover(false);

	return (
		<button
			className={classNameBTN}
			onClick={onClick}
			disabled={disabled}
			style={overrideStyle}
			onMouseOver={onMouseOver}
			onMouseLeave={onMouseLeave}
			type = "button"
		>
			{/* {!!icon && !iconOnRightSide && <img
				src={icon}
				alt='icon'
				className={classNameIMG}
			/>} */}
			{!!Icon && !iconOnRightSide && Icon({ className: classNameIMG })}
			<span
				hidden={!text}
				className={classNameTXT}
			>
				{text}
			</span>
			{!!Icon && iconOnRightSide && Icon({ className: classNameIMGRightSide })}
		</button>
	);
}

export default TextIconButton;
